var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"placeholder":"Sélectionner un statut","value":_vm.value,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default"),_vm._l((_vm.statuses),function(ref){
var id = ref.id;
var name = ref.name;
return _c('el-option',{key:id,attrs:{"value":id,"label":name,"selected":id == _vm.value}},[_vm._v(" "+_vm._s(name)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }